'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import {
  toasterApi,
  type InternalEnrichedFinding,
} from '@terra/ui-design-system';
import { useMentions } from '../../../hooks/useMentions';
import { useChatStore } from '../../../store/chatStore';
import {
  resolveSelectedFindings,
  sendFindingsToCreateChainCopilot,
} from './send-findings-to-create-chain';

export function useFindingsCreateChainCopilot() {
  const tCreateChain = useTranslations('findingsTab.createChain');
  const tSelection = useTranslations('designSystem.findingsList.selection');
  const { addMention } = useMentions();
  const appendTextToInput = useChatStore((state) => state.appendTextToInput);

  return useCallback(
    ({
      selectedIds,
      findings,
    }: {
      selectedIds: readonly string[];
      findings: readonly InternalEnrichedFinding[];
    }) => {
      const selectedFindings = resolveSelectedFindings({
        selectedIds,
        findings,
      });

      if (
        selectedFindings.length < 2 ||
        selectedFindings.length !== selectedIds.length
      ) {
        toasterApi.error({
          title: tSelection('createChainError'),
        });

        return false;
      }

      sendFindingsToCreateChainCopilot({
        findings: selectedFindings,
        prompt: tCreateChain('copilotPrompt'),
        addMention,
        appendPrompt: (text) => {
          setTimeout(() => {
            appendTextToInput(text);
          }, 0);
        },
      });

      return true;
    },
    [addMention, appendTextToInput, tCreateChain, tSelection],
  );
}
